// types
import {
	ContractStatus,
	EntitySubtype,
	EntityType,
	InvoiceStatus,
	TransactionType,
} from '../@types';

// i18
import { TFunction } from 'i18next';

export const translateLanguage = (languageCode: Intl.Locale['language']) => {
	const languages: Record<Intl.Locale['language'], string> = {
		af: 'Afrikaans',
		am: 'አማርኛ',
		ar: 'العربية',
		az: 'Azərbaycan',
		be: 'Беларуская',
		bg: 'Български',
		bn: 'বাংলা',
		bs: 'Bosanski',
		ca: 'Català',
		cs: 'Čeština',
		cy: 'Cymraeg',
		da: 'Dansk',
		de: 'Deutsch',
		el: 'Ελληνικά',
		en: 'English',
		es: 'Español',
		et: 'Eesti',
		eu: 'Euskera',
		fa: 'فارسی',
		fi: 'Suomi',
		fil: 'Filipino',
		fr: 'Français',
		ga: 'Gaeilge',
		gl: 'Galego',
		gu: 'ગુજરાતી',
		he: 'עברית',
		hi: 'हिन्दी',
		hr: 'Hrvatski',
		hu: 'Magyar',
		hy: 'Հայերեն',
		id: 'Bahasa Indonesia',
		is: 'Íslenska',
		it: 'Italiano',
		ja: '日本語',
		ka: 'ქართული',
		kk: 'Қазақ тілі',
		km: 'ខ្មែរ',
		kn: 'ಕನ್ನಡ',
		ko: '한국어',
		ky: 'Кыргызча',
		lo: 'ລາວ',
		lt: 'Lietuvių',
		lv: 'Latviešu',
		mk: 'Македонски',
		ml: 'മലയാളം',
		mn: 'Монгол',
		mr: 'मराठी',
		ms: 'Bahasa Melayu',
		mt: 'Malti',
		my: 'မြန်မာ',
		nb: 'Norsk bokmål',
		ne: 'नेपाली',
		nl: 'Nederlands',
		nn: 'Norsk nynorsk',
		or: 'ଓଡ଼ିଆ',
		pa: 'ਪੰਜਾਬੀ',
		pl: 'Polski',
		ps: 'پښتو',
		pt: 'Português',
		ro: 'Română',
		ru: 'Русский',
		si: 'සිංහල',
		sk: 'Slovenčina',
		sl: 'Slovenščina',
		sq: 'Shqip',
		sr: 'Српски',
		sv: 'Svenska',
		sw: 'Kiswahili',
		ta: 'தமிழ்',
		te: 'తెలుగు',
		th: 'ไทย',
		tr: 'Türkçe',
		uk: 'Українська',
		ur: 'اردو',
		uz: "O'zbek",
		vi: 'Tiếng Việt',
		zh: '中文（简体）',
		zu: 'IsiZulu',
	};

	return languages[languageCode] || languageCode;
};

export const translateEntityType = (type: EntityType | EntitySubtype, t: TFunction) => {
	const types: Record<EntityType | EntitySubtype, string> = {
		AUDITOR: t('auditor'),
		BENEFICIARY: t('beneficiary'),
		BORROWER: t('borrower'),
		DONOR: t('donor'),
		INDIVIDUAL: t('individual'),
		INTERMEDIARY: t('intermediary'),
		ORGANIZATION: t('organization'),
		PIU: t('piu'),
		SUB_PIU: t('subPiu'),
		SUPPLIER: t('supplier'),
		TAX_AUTHORITY: t('taxAuthority'),
	};

	return types[type] || type;
};

export const translateContractStatus = (status: ContractStatus, t: TFunction) => {
	const statuses: Record<ContractStatus, string> = {
		ACTIVE: t('active'),
		CANCELLED: t('cancelled'),
		COMPLETED: t('completed'),
		DEACTIVATED: t('deactivated'),
		DELETED: t('deleted'),
		DRAFT: t('draft'),
		SUBMITTED: t('submitted'),
	};

	return statuses[status] || status;
};

export const translateInvoiceStatus = (status: InvoiceStatus, t: TFunction) => {
	const statuses: Record<InvoiceStatus, string> = {
		APPROVED: t('approved'),
		DEACTIVATED: t('deactivated'),
		PENDING_PAYMENT: t('pendingPayment'),
		REJECTED: t('rejected'),
		PAID: t('paid'),
		PAYMENT_IN_PROGRESS: t('paymentInProgress'),
		PENDING_REVIEW: t('pendingReview'),
		READY_FOR_PAYMENT: t('readyForPayment'),
		ON_HOLD: t('onHold'),
		DRAFT: t('draft'),
	};

	return statuses[status] || status;
};

export const translateTransactionType = (type: TransactionType, t: TFunction) => {
	const types: Record<TransactionType, string> = {
		ADVANCE: t('advance'),
		CASH_BENEFIT: t('cashBenefit'),
		DIRECT: t('directPayment'),
		INITIAL: t('initialDeposit'),
		OPEX: t('operatingExpense'),
		NON_CASH_BENEFIT: t('nonCashBenefit'),
		PAYMENT: t('payment'),
		REIMBURSEMENT: t('reimbursement'),
		REPLENISHMENT: t('replenishment'),
		TRANSFER: t('transfer'),
	};

	return types[type] || type;
};
